import { useContext, useState } from "react"
import API from "./API"
import { Link, useNavigate, useParams } from "react-router"
import { useForm } from "react-hook-form"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ModalContext } from './ModalContext';
import ApiResult from './ApiResult';
import { AdminQueryCenter, AdminQueryDivision, AdminQueryUsage } from "../../backend/src/api/dto"
import ModalConfirmation from "./Modal/Confirmation"
import DisplayUsage from "./components/DisplayUsage"

type FormValues = {
    name: string
    description: string
    divisionId: number
    status: boolean
}


function Center() {
    const params = useParams();
    let navigate = useNavigate();

    const [data, setData] = useState<{
        center: AdminQueryCenter,
        usage: AdminQueryUsage[],
        divisions: AdminQueryDivision[]
    }>({
        center: {
            centerId: 0,
            name: 'string',
            description: 'string',
            divisionId: 0,
            status: false
        },
        usage: [],
        divisions: []

    })
    const [apiResult, setApiResult] = useState<null | { status: boolean, message?: string[] }>(null)
    const [showModal, closeModal] = useContext(ModalContext);

    const [loading, setLoading] = useState(true)
    const { register, control, getValues } = useForm<FormValues>({
        defaultValues: async () => {
            if (params.centerId !== "0") {
                const result = await Promise.all([
                    API.getCenter(params.centerId ?? 0),
                    API.getDivisions()
                ])
                setData(prevData => {
                    return {
                        ...prevData,
                        center: result[0].center,
                        usage: result[0].usage,
                        divisions: result[1]
                    }
                })
                setLoading(false)
                return result[0].center
            } else {
                const divisions = await API.getDivisions();
                setLoading(false)
                setData(prevData => {
                    return {
                        ...prevData,
                        divisions
                    }
                })
                return {
                    divisionId: 0,
                    name: '',
                    description: '',
                    status: false

                }
            }

        }
    })

    const reloadData = (): Promise<any> => {
        setLoading(true)

        return Promise.all([
            API.getCenter(params.centerId ?? 0),
            API.getDivisions()
        ]).then(res => {
            setData(prevData => {
                return {
                    ...prevData,
                    center: res[0].center,
                    usage: res[0].usage,
                    divisions: res[1]
                }
            })

            setLoading(false)
        }).catch(e => {
            setLoading(false)
        })
    }


    const addCenter = () => {
        API.addCenter(getValues()).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/center')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }

    const saveCenter = () => {
        return API.saveCenter(params.centerId ?? 0, getValues()).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/center')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }

    const deleteCenter = () => {
        return API.deleteCenter(params.centerId ?? 0).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/center')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }


    if (loading) {
        return (
            <div className="p-3">
                <div className="card">
                    <div className="card-header" style={{ height: '55px' }}>
                        <div className="mt-2">Stredisko: ...</div>
                    </div>
                    <div className="card-body">
                        Nahrávam
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header " style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-1">
                            <span className=""><Link to="/dashboard/center" className="btn btn-primary"><FontAwesomeIcon fixedWidth icon={["fas", "arrow-left"]} /> Späť</Link></span>
                        </div>
                        <div className="col-6">
                            <div className="mt-2">Stredisko: <strong>{
                                params.centerId === "0" ? '[ Vytvoriť nové ]' : getValues().name
                            }</strong></div>
                        </div>
                        <div className="col-5 text-end">
                            {
                                params.centerId === "0" ?
                                    <button className="btn btn-primary" onClick={addCenter}><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} />  Pridať stredisko</button>
                                    :
                                    <>
                                        {
                                            !loading && !data.usage.length ?
                                                <button className="btn btn-danger me-3" onClick={() => showModal(
                                                    <ModalConfirmation
                                                        confirm={deleteCenter}
                                                        title={"Naozaj zmazať stredisko?"}
                                                        text="" />
                                                )}><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} />  Zmazať stredisko</button>
                                                : null
                                        }
                                        <button className="btn btn-primary" onClick={saveCenter}><FontAwesomeIcon fixedWidth icon={["fas", "floppy-disk"]} />  Uložiť stredisko</button>
                                    </>

                            }
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <ApiResult errorObject={apiResult} />
                    <div className="row">
                        <div className="col-4">
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">ID strediska</label>
                                </div>
                                <div className="col-auto">
                                    <input type="text" {...register("name")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Názov strediska</label>
                                </div>
                                <div className="col-8">
                                    <input type="text" {...register("description")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Divízia</label>
                                </div>
                                <div className="col-8">
                                    <select {...register("divisionId")} className="form-select form-select-sm" >
                                        {
                                            data.divisions.map(division => {
                                                return (
                                                    <option value={division.divisionId}>{division.name}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-4  mt-1 text-end">
                                    <label className="form-label">Aktívne</label>
                                </div>
                                <div className="col-8  mt-1">
                                    <div className="form-check">

                                        <input className="form-check-input" {...register("status")} type="checkbox" />
                                        <label className="form-check-label">

                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="offset-4 col-4">
                            {
                                params.centerId !== "0" ?
                                    <>
                                        <h4>Odkazy na toto stredisko</h4>
                                        <DisplayUsage data={data.usage} />
                                    </>
                                    : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Center